import { Box, Flex, Heading } from '@chakra-ui/react';
import { ReactNode } from 'react';
import { StackToStaticPages } from '../Links/StackToStaticPages';
import MaskImage from '../../assets/img/WhiteMaskBg.png';

interface IUserContentLayout {
  caption?: string;
  children?: ReactNode;
}

export const UserContentLayout = ({ caption, children }: IUserContentLayout) => {
  return (
    <Flex
      minH='100%'
      flexDir='column'
      justifyContent='space-between'
      alignItems='flex-start'
      overflowY='auto'
      px={{ base: 6, lg: 12 }}
      pt={{ base: 24, lg: 10 }}
      pb={8}
      borderLeftRadius={{ base: 0, lg: '20px' }}
      boxShadow='-500px 0 0 var(--chakra-colors-brand-blueExtraDark)'
      sx={{
        background: `url(${MaskImage}) bottom right no-repeat, #fff`,
      }}
    >
      <Box w='100%'>
        {caption ? (
          <Heading variant='bigCaption' textAlign='left' fontSize={{ base: '4xl', lg: '6xl' }}>
            {caption}
          </Heading>
        ) : null}
        {children}
      </Box>

      <StackToStaticPages color='gray.400' fontSize='xs' mt={8} />
    </Flex>
  );
};
